module.exports = __webpack_public_path__ + "img/iata1.c8c17237.png";